import {
    _137C,
    _311C,
    backgroundColorWhite,
    ClearWhite,
    ColorGrey6,
    ColorWhite,
    FreshAsphalt,
    FreshAsphalt50,
    Blue,
    Link,
    Purple,
    ReflexBlue,
    SpbSky0,
    SpbSky1,
    SpbSky150,
    WarmRedC,
    SpbSky2,
} from './palette';

export const pageDashboardContainerBgColor = ColorGrey6;
export const pageDashboardWidgetBlockBgColor = backgroundColorWhite;
export const pageDashboardWidgetText = FreshAsphalt;
export const pageDashboardWidgetSecondaryText = FreshAsphalt50;
export const pageDashboardWidgetWarningText = WarmRedC;
export const pageDashboardWidgetLink = Link;
export const pageDashboardWidgetCircleBgColor = SpbSky0;

// borderBottom
export const pageDashboardBorderBottomActive = Blue;
export const pageDashboardBorderBottomNoActive = SpbSky1;

// chart
export const pageDashboardChartEmptyColor = SpbSky0;
export const pageDashboardChartOneTimeCharges = Link;
export const pageDashboardChartOtherRecurringCharges = _137C;
export const pageDashboardChartRecurringChargesForRatePlan = Blue;
export const pageDashboardChartStroke = ColorWhite;
export const pageDashboardChartTextColor = FreshAsphalt;
export const pageDashboardChartTextColorSecondary = FreshAsphalt50;
export const pageDashboardChartTooltipBgColor = ColorWhite;
export const pageDashboardChartTrafficChargesAtHomeMacroRegionAndNotInHomeRegion = _311C;
export const pageDashboardChartTrafficChargesAtHomeRegion = Purple;
export const pageDashboardChartTrafficChargesAtOutHomeMacroRegion = ReflexBlue;
export const pageDashboardChartTrafficChargesAtRoaming = WarmRedC;

// SearchAccounts
export const pageDashboardSearchAccountsBgColor = ClearWhite;
export const pageDashboardSearchAccountsBorderColor = SpbSky2;
export const pageDashboardSearchAccountsListBodyBgColor = ClearWhite;
export const pageDashboardSearchAccountsListHeaderTextColor = FreshAsphalt50;
export const pageDashboardSearchAccountsListHoverBgColor = SpbSky150;
export const pageDashboardSearchAccountsTextColorSecondary = FreshAsphalt50;
